import React from "react";
import Select from "react-select";
import { ButtonGroup, Button, Tabs, Tab } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartLine, faChartBar, faQuestion } from "@fortawesome/free-solid-svg-icons";

import { ORIGINAL_STEPS, STEP_TYPE, MODEL_TYPES, AIBLE_MODES } from "containers/Wizard/reducer";

import AibleStep from "containers/CreateWizard/AibleStep";
import ChooseDatasetContainer from "containers/CreateWizard/Dataset/ChooseDataset";
import BlueprintTile from "components/Tiles/BlueprintTile";

import AibleBot from "images/wiz3.png";
import AibleQuickBot from "images/wiz2.png";
import HalIcon from "images/wiz1.png";

import Optimized from "images/optimized.svg";
import Academic from "images/academic.svg";

import LineChart from "images/chart-line-light.svg";
import BarChart from "images/chart-bar-light.svg";

import styles from "./style.module.css";

export default class WizardStart extends React.PureComponent {
  renderSelectModelType() {
    const { modelType, updateModelType, selectedDataset } = this.props;

    return (
      <div>
        <AibleStep
          message={"Let's start by choosing the type of models you would like to build"}
          secondaryMessage={"You may choose to build either regression or classification models"}
        />
        <div className={styles.startButtonHolder}>
          {Object.keys(MODEL_TYPES).map((m, i) => (
            <div
              key={i}
              className={styles.aibleTile + " " + (modelType === MODEL_TYPES[m] ? styles.aibleActiveTile : "")}
              onClick={() => !selectedDataset && updateModelType(MODEL_TYPES[m])}
              id={"aible" + MODEL_TYPES[m]}
            >
              <div className={styles.startIcon}>
                {MODEL_TYPES[m] === MODEL_TYPES.CLASSIFICATION ? (
                  <img src={LineChart} className={styles.sIcon} />
                ) : (
                  <img src={BarChart} className={styles.sIcon} />
                )}
                <div className={styles.topMsg}>{MODEL_TYPES[m].replace("_", " ").toLowerCase()}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderSelectAibleMode() {
    const { blueprintId, aibleMode, updateAibleMode } = this.props;

    return (
      <div className={styles.selectMode}>
        <AibleStep
          message={"Which template would you like to use to start building the new Blueprint?"}
          secondaryMessage={"You may choose to use a pre-built Aible template, or start with a blank template."}
        />
        <div className={styles.startButtonHolder}>
          <BlueprintTile
            className={aibleMode === AIBLE_MODES.AIBLE ? styles.aibleActiveTile : ""}
            onClick={() => updateAibleMode(AIBLE_MODES.AIBLE)}
            isAible
          />
          {blueprintId !== "Academic" && (
            <div
              className={styles.aibleTile + " " + (aibleMode === AIBLE_MODES.CUSTOM ? styles.aibleActiveTile : "")}
              onClick={() => updateAibleMode(AIBLE_MODES.CUSTOM)}
            >
              <div className={styles.aibleIcon}>
                <FontAwesomeIcon icon={faQuestion} />
              </div>
              <div className={styles.mid}>{"Custom"}</div>
              <div className={styles.bottom}>
                <div>{"User created flow"}</div>
                <div>{"Access to all possible steps"}</div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  render() {
    const { blueprintId, selectedDataset, modelType, aibleMode, isEditBlueprint } = this.props;

    return (
      <div className={styles.wizardStart}>
        {blueprintId == "new" && this.renderSelectAibleMode()}
        {(isEditBlueprint ||
          ((blueprintId === "new" || blueprintId === "template") &&
            aibleMode !== undefined &&
            selectedDataset === undefined)) &&
          this.renderSelectModelType()}
      </div>
    );
  }
}
